export default __webpack_public_path__ + "static/logo-ucf-ac7aebf8551e8656b8587aa74d57a340.jpg";